import React, { useState } from "react";
import Layout from "../shared/Layout";
import { ImportTemplate } from "../../_services";
import { ToastContainer } from "react-toastify";
import { toast } from "react-toastify";

const BulkProductUpload = () => {
    const [formData, setFormData] = useState({
        file: null,
    });

    const handleFileChange = (e) => {
        setFormData({
            ...formData,
            file: e.target.files[0],
        });
    };

    const onBulkUpload = async (e) => {
        e.preventDefault();

        if (!formData.file) {
            toast.error("Please select a file to upload.");
            return;
        }

        const uploadData = new FormData();
        uploadData.append("file", formData.file);
        try {
            await ImportTemplate(uploadData);
            setFormData({ file: null });

            document.getElementById("file").value = "";
        } catch (error) {
            toast.error("Please try again later.");
        }
    };

    return (
        <Layout>
            <ToastContainer
                autoClose={400}
                hideProgressBar={true}
                closeOnClick
                pauseOnHover
                draggable
                className='toaster'
            />
            <div className="admin-page px-4">
                <div className="admin-page mt-3 d-sm-flex justify-content-between align-items-center">
                    <div className="admin-heading" style={{ gap: "20px" }}>
                        <h4 className="mb-0">Bulk Product Upload</h4>
                    </div>
                </div>
                <div className="datatable mt-3">
                    <form onSubmit={onBulkUpload} className="form-buttons">
                        <div className="d-flex align-items-center">
                            <input
                                type="file"
                                className="form-control-file"
                                id="file"
                                name="file"
                                onChange={handleFileChange}
                            />
                        </div>
                        <div className="upload_btn mt-2">
                            <button type="submit" className="">
                                Submit
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </Layout>
    );
};

export default BulkProductUpload;
